<script>
import moment from 'moment';
import API from '../services/api';

const api = new API();

module.exports = {
  template : '#articles-template',
  data     : function() {
    return {
      search : '',
      hide   : [],
      all    : false
    };
  },
  methods : {
    showAll : function() {
      this.all = true;
      while (this.hide.length) {
        this.hide.pop();
      }
      this.$forceUpdate();
    },
    browseBrands : function(event) {
      if (event.target.value.length > 3) {
        let value = event.target.value;
        let brands = this.$store.state.brands;
        let re = new RegExp(value, 'gi');

        brands = brands.reduce((result, brand) => {
          if (re.test(brand.id)) {
            result.push(brand);
          }
          return result;
        }, []);

        this.results = brands;
      }
    },
    setBrand : function(brand) {
      let articles = this.$store.state.articles;

      if (articles.selected.indexOf(brand) < 0) {
        articles.loading = true;
        articles.selected.push(brand);

        this.$store.state.articles = articles;

        api
          .getArticles({ brand : brand })
          .then(res => {
            articles.items.push({
              brand : brand,
              items : res
            });
            this.loading = false;
            this.$store.state.articles = articles;
          })
          .catch(error => {
            //console.log(error.statusText);
          });
      }
      this.results = [];
    }
  },
  computed : {
    articles : function() {
      let articles = this.$store.state.articles;

      let items = [];

      for (let i = 0; i < articles.length; i++) {
        let category = articles[i];

        items = items.concat(
          category.items.map(article => {
            article.brand = category.brand;
            return article;
          })
        );
      }

      if (this.search.length > 2) {
        let terms = this.search.split(' ');
        let results = [];

        for (let i = 0; i < terms.length; i++) {
          let term = terms[i];

          if (term != '') {
            results = results.concat(
              items.reduce((result, item) => {
                let re = new RegExp(term, 'gi');

                if (re.test(item.title)) {
                  result.push(item);
                }
                return result;
              }, [])
            );
          }
        }

        items = results;
      }

      let ids = [];
      let self = this;
      let i = 0;

      if (!self.all)
        items = items.reduce((result, item) => {
          if (ids.indexOf(item.id) < 0) {
            result.push(item);
            ids.push(item.id);
            if (i > 19) self.hide.push(item.id);
            i++;
          }
          return result;
        }, []);

      items.sort((a, b) => a.date < b.date);

      return {
        items   : items,
        total   : items.length - this.hide.length,
        loading : this.$store.state.articles ? false : true
      };
    }
  }
};
</script>